<template>
  <div class="sign-up signup-page" v-if="dataLoaded">
    <div class="flex" v-on:keyup.enter="createAccount">
      <div class="flex-col-left hero-banner">
        <header class="signup-header">
          <a :href="homeUrl" class="rz-logo">
            <img class="logo" src="@/assets/rca-logo-white.svg" alt="Cricket API Logo" />
          </a>
          <div
            class="user-info"
            v-if="($route.name !== 'signUp') && ($route.name !== 'login')"
          >
          <template v-if="activeUser && activeUser.name">
            <svg class="profile-icon">
              <use v-bind="{'xlink:href':'#profile-icon'}" />
            </svg>
            <span class="user-name">{{ activeUser.name }}</span>
            <UserDropdown />
          </template>
          </div>
        </header>
        <h1 class="hero-banner--title" v-if="page.title">{{ page.title }}</h1>
        <div>
          <template v-for="section in page.sections[1].detail">
            <template>
              <div v-for="info in section" :key="info.key">
                <svg>
                  <use v-bind="{'xlink:href':'#check-icon'}" />
                </svg>
                <div class="content-wrapper">
                  <h2>{{info.name}}</h2>
                  <p>{{info.desc}}</p>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div class="flex-col-right" :class="[signUpInitiated ? 'initiated' : null]">
        <div class="form-wrapper">
          <h1 class="signup-text">Create your Roanuz account</h1>
          <p class="login-info">
            Already have an account?
            <router-link class="login-info-link" :to="{ name: 'login', query: loginParams }">Sign in</router-link>
          </p>
          <div class="register-form">
            <div :class="['form-group', (formFields.name.showError ? 'error-field' : '')]">
              <label class="field-label" for="fullname">Full name</label>
              <input
                :class="[!formFields.name.showError ? 'tick-icon' : null]"
                type="text"
                v-model="userInfo.name"
                name="fullname"
                id="fullname"
                placeholder=" "
                autocomplete="off"
                autofocus
              />
              <p v-if="formFields.name.showError" class="error-msg">{{formFields.name.errorMsg}}</p>
            </div>
            <div :class="['form-group', (formFields.email.showError ? 'error-field' : '')]">
              <label class="field-label" for="workemail">Work email</label>
              <input
                :class="[!formFields.email.showError ? 'tick-icon' : null]"
                type="email"
                v-model="userInfo.email"
                name="workemail"
                id="workemail"
                placeholder=""
                autocomplete="off"
              />
              <p v-if="formFields.email.showError" class="error-msg">{{formFields.email.errorMsg}}</p>
            </div>
            <div :class="['form-group password-div', (formFields.password.showError ? 'error-field' : '')]">
              <label class="field-label password" for="password">Password</label>
              <input
                :class="[!formFields.password.showError ? 'tick-icon' : null]"
                type="password"
                v-model="userInfo.password"
                name="password"
                id="password"
                placeholder=" "
                autocomplete="on"
              />
              <p v-if="formFields.password.showError" class="error-msg">{{formFields.password.errorMsg}}</p>
            </div>
            <div :class="['form-group', (formFields.companyName.showError ? 'error-field' : '')]">
              <label class="field-label" for="fullname">Company</label>
              <input
                :class="[!formFields.companyName.showError ? 'tick-icon' : null]"
                type="text"
                v-model="userInfo.company_name"
                name="company"
                id="company"
                placeholder=" "
                autocomplete="off"
              />
              <p v-if="formFields.companyName.showError" class="error-msg">{{formFields.companyName.errorMsg}}</p>
            </div>
            <label class="check-box-group terms-and-conditions">
              By clicking Create Account, you agree to our and
              <span class="link-item">
                <a href="https://www.cricketapi.com/legal/Terms-of-use/"
                target="_blank"> Terms & Conditions</a> and
                <a href="https://www.cricketapi.com/legal/Privacy-Policy/"
                target="_blank">Privacy Policy</a>
              </span>
            </label>
            <div class="alert alert-warning" v-if="errorMessage">
              <p>{{errorMessage}}</p>
            </div>
            <button :disabled="showLoader && validateSubmit" class="console-btn"
            :class="[validateSubmit ? 'disabled-btn': '']"
            type="submit" @click="createAccount">
              <div v-if="!loadingState.status.isLoaded">
                <rz-request-state :state="loadingState" />
              </div>
              <span v-if="showSignup">Create Account</span>
            </button>
            <!-- <p class="text-or">OR</p>
            <div class="social-signup-group">
              <button type="button" class="signup-btn">
                <svg class="google-icon">
                  <use v-bind="{'xlink:href':'#google-icon'}" />
                </svg>Sign Up
              </button>
              <button type="button" class="signup-btn">
                <svg class="github-icon">
                  <use v-bind="{'xlink:href':'#github-icon'}" />
                </svg>Sign Up
              </button>
            </div> -->
          </div>
        </div>
        <footer class="footer">
          <div class="footer-flex-col-left">
            <p>© Roanuz Softwares Private Limited</p>
          </div>
          <div class="footer-flex-col-right"
            v-if="tocLinks.linkslist">
            <template v-for="(linkItem, index) in tocLinks.linkslist.links">
              <rz-link-item :key="index" :link="linkItem" />
            </template>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.author-info {
  .image-item,
  img {
    border-radius: 50%;
    max-width: size(55);
    min-width: size(55);
    max-height: size(55);
    min-height: size(55);
  }
}

.check-box-group {
  .link-item {
    display: inline-block;
    .link-plain {
      color: var(--onboard-link-color);
      padding-right: size(15);
      background-image: url('../../assets/link-arrow.svg');
      background-repeat: no-repeat;
      background-position: 100% 50%;
    }
  }
}
.header {
  .user-info {
    height: size(28);
    padding: size(13.5) 0;
    position: relative;
    & .user-dropdown {
      display: none;
    }
    &:hover .user-dropdown {
      display: block;
    }
    .user-name {
      display: inline-block;
      padding-left: size(13);
      font-size: size(20);
      line-height: size(24);
      color: var(--ca-title-color);
      margin-left: size(0);
      cursor: pointer;
    }
  }
}
.agile {
  width: 100%;
}
.agile__actions {
  margin-top: size(60);
}
.agile__nav-button {
  opacity: 0;
}
.agile__dot {
  margin: 0 size(12) 0 0;
}
.agile__dot button {
  background-color: rgba(79, 55, 200, 0.2);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: size(12);
  width: size(12);
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
.agile__dot--current button,
.agile__dot:hover button {
  background-color: var(--onboard-link-color);
}

.image-area {
  .show-container {
    img {
      max-height: size(435);
    }
  }
}
</style>

<style lang="scss" scoped>
  .form-group {
    display: flex;
    flex-flow: column;
  }
</style>

<script>
import { mapState } from 'vuex';
import Config from '@/config';
import { allMetaMixins } from '@/mixin/meta';

import { RequestState, RequestStateStatus } from '@/api/core';

import { User } from '@/store/modules/user';
import { FieldHandler } from '@/core/utils/formModels';
import '@/assets/styles/views/form.scss';

export default {
  mixins: allMetaMixins(),
  title: 'Create your Roanuz account | Roanuz Cricket API',
  computed: {
    ...mapState({
      dataLoaded: (state) => state.page.activePageState.status.isLoaded,
      pageState: (state) => state.page.activePageState,
      page: (state) => state.page.activePage,
      tocLinks: (state) => state.link.cricketFooterTOC,
    }),
    validateSubmit() {
      if ((this.userInfo.email === null) || (this.userInfo.password === null)
        || ((this.userInfo.company_name === null) || (this.userInfo.name === null)
        || (this.userInfo.email === '') || (this.userInfo.password === ''))
        || ((this.userInfo.company_name === '') || (this.userInfo.name === ''))) {
        return true;
      }
      return false;
    },
    loginParams() {
      if (this.$route && this.$route.query && this.$route.query.next_url) {
        return { next_url: this.$route.query.next_url };
      }
      if (this.$route && this.$route.query && this.$route.query.next) {
        return { next: this.$route.query.next };
      }
      return { next: '/user/project/create/' };
    },
  },

  serverPrefetch() {
    return this.fetchData();
  },

  mounted() {
    if (!this.dataLoaded) {
      this.fetchData();
    }
    if (this.dataLoaded) {
      const sameRoute = this.page.route_value.includes(this.$route.meta.routeValue);
      if (!sameRoute) {
        console.log('Refreshing page because page mounted with different route');
        this.refreshPage();
      }
    }
  },

  watch: {
    $route(to, from) {
      if (
        to.path !== from.path
        || to.params.sport !== from.params.sport
        || to.params.page !== from.params.page
      ) {
        console.log('Refreshing page because route change');
        this.refreshPage();
      }
    },
  },

  data() {
    return {
      loadingState: new RequestState(),
      userInfo: new User(),
      // isTermsChecked: false,
      isTermsChecked: true,
      isCheckedWarning: false,
      signUpInitiated: false,
      errorMessage: null,
      showLoader: false,
      showSignup: true,
      homeUrl: Config.cricketHost,
      linkItemList: [
        {
          text: 'API terms of use.',
          url: `${Config.cricketHost}/legal/API-Terms-of-use/`,
        },
        {
          text: 'Terms & Privacy policy.',
          url: `${Config.cricketHost}/legal/Privacy-Policy/`,
        },
        {
          text: 'Refund policy',
          url: `${Config.cricketHost}/legal/Refund-Policy/`,
        },
      ],
      formFields: {
        email: new FieldHandler({
          errorMsg: 'Please enter a valid email.',
          // eslint-disable-next-line max-len
          regExp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        }),
        password: new FieldHandler({
          errorMsg: 'Password must be least 8 characters long with a mix of letters, numbers and symbols.',
          regExp: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,30}$/,
          minValue: 8,
        }),
        name: new FieldHandler({
          errorMsg: 'Please enter your Full name.',
        }),
        companyName: new FieldHandler({
          errorMsg: 'Please enter a valid company name.',
        }),
        response: new FieldHandler({
          errorMsg: 'Something went wrong!',
        }),
      },
    };
  },
  methods: {
    fetchData() {
      const route = '/user/pages/';
      const routeValue = 'signup';
      return this.$store
        .dispatch('page/fetchActivePage', { route, routeValue })
        .catch((err) => {
          console.error('Error on fetch Active Page', err);
        });
    },

    processNext(user) {
      const successUrl = decodeURI(this.$route.query.next_url);
      this.$store.commit('boot/updateUser', { user });
      if (this.$route.query.next_url) {
        console.log(`Signup Completed ${user.name}, Moving to ${successUrl}`);
        window.location.href = successUrl;
      } else {
        const successRoute = decodeURI(this.$route.query.next || '/user/project/create/');
        console.log(`Signup Completed ${user.name}, Moving to ${successRoute}`);
        this.$router.push(successRoute);
      }
    },

    createAccount() {
      /* eslint-disable operator-linebreak */
      this.signUpInitiated = true;
      this.showSignup = false;
      if (this.validateForm()) {
        this.loadingState.status = RequestStateStatus.Loading;
        User.createUser(this.$apiInstance, this.userInfo)
          .then(({ user, error }) => {
            this.loadingState.status = RequestStateStatus.Loaded;
            this.showSignup = true;
            if (error) {
              console.log('Invalid Signup Request', error);
              this.errorMessage = error.message;
            } else {
              this.processNext(user);
            }
          }).catch((err) => {
            this.errorMessage = 'Internal Error';

            this.loadingState.status = RequestStateStatus.Error;
            this.loadingState.ref = err;
            console.error('Unhandled error during Signup', err);
          });
      } else {
        this.showSignup = true;
      }
    },
    validateForm() {
      let count = 0;
      if (this.userInfo.password === '' || this.userInfo.password === null) {
        this.formFields.password.errorMsg = 'Please provide a password.';
      } else {
        // eslint-disable-next-line max-len
        this.formFields.password.errorMsg = 'Password must be least 8 characters long with a mix of letters, numbers and symbols.';
      }
      if (!this.formFields.name.validateField(this.userInfo.name)) {
        count += 1;
      }
      if (!this.formFields.email.validateField(this.userInfo.email)) {
        count += 1;
      }
      if (!this.formFields.password.validateField(this.userInfo.password)) {
        count += 1;
      }
      if (!this.formFields.companyName.validateField(this.userInfo.company_name)) {
        count += 1;
      }
      return (count === 0);
    },
    refreshPage() {
      this.$store.commit('page/resetActivePage');
      this.fetchData();
    },
    buildURL(base, params) {
      const q = Object.keys(params).map((key) => [key, params[key]].map(encodeURIComponent).join('=')).join('&');
      return `${base}?${q}`;
    },
  },
};
</script>
